import { showBanner, dismissCurrentBanner } from './banner/index.tsx';
import {
	registerBottomRightCornerContainer,
	insertBottomRightCornerPortal,
	removeBottomRightCornerPortal,
} from './bottom-right-corner/index.tsx';
import { setIsChromeless } from './chromeless/index.tsx';
import { setIsFullscreen } from './fullscreen/index.tsx';
import { setLeftSidebarState } from './left-sidebar/index.tsx';
import {
	setRightSidebarState,
	openRightSidebar,
	closeRightSidebar,
	closeAllRightSidebar,
	closeCurrentRightSidebar,
	minimiseRightSidebar,
} from './right-sidebar/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { RightSidebarControllerType } from './right-sidebar';

export const actions = {
	// global
	setIsChromeless,
	setIsFullscreen,

	// banner
	showBanner,
	dismissCurrentBanner,

	// left-sidebar
	setLeftSidebarState,

	// right-sidebar
	setRightSidebarState,
	openRightSidebar,
	closeRightSidebar,
	closeAllRightSidebar,
	closeCurrentRightSidebar,
	minimiseRightSidebar,

	// bottom-right-corner
	registerBottomRightCornerContainer,
	insertBottomRightCornerPortal,
	removeBottomRightCornerPortal,
} as const;

export type LayoutActions = typeof actions;
